import React from 'react';
import './Body.scss';
import YoungGuyHeadshot from '../../assets/Young, Guy_Headshot_rgb@2x.png';
import SingletonTamiHeadshot from '../../assets/Singleton, Tami_rgb@2x.png';
import BensenDebbieHeadshot from '../../assets/Bensen-Kennedy, Debbie_rgb@2x.png';

const moderators = [
  {
    image: YoungGuyHeadshot,
    name: 'Guy Young, MD',
    attributes: [
      'Professor of Pediatrics, University of Southern California',
      'Director, Hemostasis and Thrombosis Center',
      'Children’s Hospital Los Angeles',
      'Los Angeles, California'
    ]
  }
];

const faculty = [
  {
    image: SingletonTamiHeadshot,
    name: 'Tammuella Singleton, MD',
    attributes: [
      'Chief, Pediatric Hematology',
      'Director, Hemophilia Treatment Center',
      'Mississippi Center for Advanced Medicine',
      'Madison, Mississippi'
    ]
  },
  {
    image: BensenDebbieHeadshot,
    name: 'Debbie Benson-Kennedy, MD',
    attributes: [
      'Vice President, Medical Affairs North America',
      'CSL Behring',
      'King of Prussia, Pennsylvania'
    ]
  }
];

function Speaker({ speaker }) {
  return (
    <div className="speaker">
      <img className="speaker-image" src={speaker.image} alt={speaker.name} />
      <div className="speaker-info">
        <div className="speaker-name">{speaker.name}</div>
        {speaker.attributes.map((attribute) => (
          <div className="speaker-attribute">{attribute}</div>
        ))}
      </div>
    </div>
  );
}

function Body() {
  return (
    <div className="body-container">
      <div className="video-section">
        <p>
          Learn more about HEMGENIX, the first and only FDA-approved gene therapy for Hemophilia B.{' '}
          <span style={{ fontWeight: '600' }}>
            Click the video below to watch expert panelists present the clinical data and answer
            audience questions about HEMGENIX.
          </span>
        </p>
        <p>
          This presentation is now available for on-demand viewing. It originally was delivered as a
          live national broadcast after HEMGENIX was approved by the US Food and Drug Administration
          for Hemophilia B.{' '}
        </p>
        <div className="video">
          <iframe
            title="HEMGENIX"
            src="https://players.brightcove.net/5848624617001/default_default/index.html?videoId=6326264999112"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div className="blurb">
          <div className="blurb-heading">For more information about HEMGENIX:</div>
          <ul className="bullets">
            <li>Contact your local CSL Behring Manager of Coagulation Products</li>
            <li>
              Visit{' '}
              <a rel="noreferrer" href="https://www.hemgenix.com/hcp" target="_blank">
                HEMGENIX.com/hcp
              </a>{' '}
            </li>
          </ul>
        </div>
      </div>
      <div className="speaker-section">
        <h3 className="speaker-section-heading">
          HEAR FROM A PANEL OF RECOGNIZED EXPERTS IN GENE THERAPY RESEARCH
        </h3>
        <ul className="speaker-bullets">
          <li>Understand why Hemophilia B is a target for gene therapy</li>
          <li>Learn about the clinical trials, efficacy data, and safety profile for HEMGENIX</li>
          <li>Identify patient characteristics for which HEMGENIX may be an option</li>
        </ul>
        <h3 className="speaker-section-heading">NATIONAL BROADCAST SPEAKERS</h3>
        <h4 className="speaker-section-subheading">Moderator:</h4>
        <div className="moderator">
          {moderators.map((moderator) => (
            <Speaker speaker={moderator} />
          ))}
        </div>
        <h4 className="speaker-section-subheading" style={{ marginTop: '15px' }}>
          Faculty:
        </h4>
        <div className="faculty">
          {faculty.map((faculty) => (
            <Speaker speaker={faculty} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Body;
